import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const ShortRedirect = () => {
  const { code } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const { data } = await axios.get(`${API}/short/${code}`);
        if (!cancelled && data.pingme_id) {
          navigate(`/ping/${data.pingme_id}`, { replace: true });
        }
      } catch (err) {
        if (!cancelled) setError(err.response?.data?.detail || 'Code introuvable');
      }
    })();
    return () => { cancelled = true; };
  }, [code, navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6 py-12">
      <div className="text-center">
        {error ? (
          <>
            <h1 className="font-heading font-bold text-2xl text-charcoal mb-2">Code introuvable</h1>
            <p className="text-charcoal/60 text-sm">{error}</p>
          </>
        ) : (
          <>
            <div className="w-12 h-12 border-4 border-charcoal/20 border-t-charcoal rounded-full animate-spin mx-auto mb-4" />
            <p className="text-charcoal/60">Redirection...</p>
          </>
        )}
      </div>
    </div>
  );
};

export default ShortRedirect;
